module.exports = __webpack_public_path__ + "img/doc.4d66b9bc.jpg";